export class HRPerformanceTemplate {
  id:                     string;
  hrConfigId:             string;
  ownerEmployeeId:        string;
  title:                  string;
  description:            string;
  includeKRA:             boolean = true;
  weightKRA:              number = 1;
  includeCompetency:      boolean= true;
  weightCompetency:       number = 1;
  includeAbility:         boolean= true;
  weightAbility:          number = 1;
  includeGoal:            boolean= true;
  weightGoal:             number = 1;
  includeReview360:            boolean= true;
  weightReview360:             number = 1;
  autoReviewByEmployee:      boolean = true;
  addManagerAsReviewer:      boolean = true;


  ownerLastname: string;
  ownerFirstname: string;

}
